module.exports = __webpack_public_path__ + "img/no-order.b195cd6a.png";